module.exports = __webpack_public_path__ + "img/30.28527f6c.png";